module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAPRJREFUOE/t1L8uREEUx/HPUemoKEWi1Pi3FUqi01mFeAfNtsTDoKFRCQ+A8ALrJVRUjkyyV6zCvXezjcQkU83Jd+b85uQbxrxizDxDwMxcwRyuMINNTNRc2o+I56rmC5iZy3jEbURsZ2YfCw06+EAnIp5K7XfgHs7Ljoj9zMwGsKqkGxEX/8BsmuFxRJyUvDLzDN2y22b4jh4OB7+wHhFvowILbBc3mB4AO1jF4igv3ME9rnE6GLVLTOIVU21bPsIBln6Zy9YZ1s34HwUW0zzgLiK2WsphrTLOT30V48yj/OIsNhro66UyzZAc6lJvej52Y38C/KCuFSVeQt4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newscategory4.png
// module id = lU3M
// module chunks = 1